import { render } from "./CircleMessage.vue?vue&type=template&id=2c96c098&scoped=true"
import script from "./CircleMessage.vue?vue&type=script&lang=js"
export * from "./CircleMessage.vue?vue&type=script&lang=js"

import "./CircleMessage.vue?vue&type=style&index=0&id=2c96c098&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c96c098"]])

export default __exports__